import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { SurveyFilter as SurveyFilterModel, SurveyFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const SurveyFilter = (props: { filter: SurveyFilterModel; setFilter: (value: SurveyFilterModel) => void }) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<SurveyFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.surveys.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const formModeField = () => {
    const propertyName = pn<SurveyFilterModel>("formModeId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.formModes?.find((x) => x.id === props.filter.formModeId)}
        options={resource.formModes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.formModeId = value?.id;
            })
          )
        }
      />
    );
  };

  const formTypeField = () => {
    const propertyName = pn<SurveyFilterModel>("formTypeId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.formTypes?.find((x) => x.id === props.filter.formTypeId)}
        options={resource.formTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.formTypeId = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {formModeField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {formTypeField()}
      </Grid>
    </Grid>
  );
};
